module.exports = __webpack_public_path__ + "img/icon@2x.4f8934d3.png";